<p>viewflattedgala works!</p>
